// @ngInject
function invoiceConfirmationDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(message, deliveryDate, earliestAllowedDeliveryDate) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'invoiceConfirmationDialogController as vm',
            templateUrl: 'services/dialogs/InvoiceConfirmationDialog/InvoiceConfirmationDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            message: function() {
                return message;
            },
            deliveryDate: function() {
                return deliveryDate;
            },
            earliestAllowedDeliveryDate: function() {
                return earliestAllowedDeliveryDate;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function invoiceConfirmationDialogController($uibModalInstance, message, deliveryDate, earliestAllowedDeliveryDate, $sce) {
    var vm = this;

    //Properties
    vm.message = $sce.trustAsHtml(message);
    vm.deliveryDate = deliveryDate;
    vm.earliestAllowedDeliveryDate = earliestAllowedDeliveryDate;

    //Methods
    vm.closeModal = closeModal;
    vm.setWijmoInputDateLimits = setWijmoInputDateLimits;

    function closeModal(isCompleted) {
        $uibModalInstance.close({ isCompleted: isCompleted, deliveryDate: vm.deliveryDate });
    }

    function setWijmoInputDateLimits(s) {
        if (vm.earliestAllowedDeliveryDate) {
            s.min = parseDate(vm.earliestAllowedDeliveryDate);
        } else {
            s.min = new Date(2016, 1, 1, 0, 0, 0, 0);
        }
        s.max = parseDate(new Date());
    }

    //Transform from string to Date, and make sure date has correct timezone and no time information
	function parseDate(input) {
		if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
		} else {
			return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
		}
	}
}

angular
    .module('services.dialogs.InvoiceConfirmationDialog', [])
    .service('invoiceConfirmationDialogService', invoiceConfirmationDialogService)
    .controller('invoiceConfirmationDialogController', invoiceConfirmationDialogController);
